import { render, staticRenderFns } from "./LoadingComponent.vue?vue&type=template&id=ed8be2f6"
import script from "./LoadingComponent.vue?vue&type=script&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed8be2f6')) {
      api.createRecord('ed8be2f6', component.options)
    } else {
      api.reload('ed8be2f6', component.options)
    }
    module.hot.accept("./LoadingComponent.vue?vue&type=template&id=ed8be2f6", function () {
      api.rerender('ed8be2f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LoadingComponent.vue"
export default component.exports